import * as React from 'react';
import { appTimingUtil } from './utils';
import { useLocation } from 'react-router-dom';

// This component is used to detect route change
// and record the soft navigation start time
export default function NavigationDetection() {
  const { pathname } = useLocation();

  const isFirstChange = React.useRef(true);

  React.useLayoutEffect(() => {
    if (!isFirstChange.current) {
      appTimingUtil.recordSoftNavigationChanged();
    }
    isFirstChange.current = false;
  }, [pathname]);

  return null;
}
